import axios from "../axios";

const submitOtp = async function (accessToken, uuid, data) {
    try {
        const response = await axios.post('/bank-account/submitOtp', {
            uuid,
            otp: data?.otp ?? ''
        }, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status,
            message: e.response?.data?.message,
            data: e.response?.data?.data
        }
    }
}

export default submitOtp;
